export default {
  languageText: 'English',
  'header.activityIncome': 'New User Rewards',
  'header.message': 'Messages',
  'header.userCenterTip': 'User Center',
  'header.userCenter': 'User Center',
  'header.logout': 'Log Out',
  'header.loginOrRegister': 'Login / Register',
  'header.commonEntries': 'Popular Product',
  'footer.address': 'Address: Room 6-702, China AI Town, No.1818-2 Wenyi West Road, Yuhang District, Hangzhou',
  'footer.phone': 'Hotline: 0571-86395960',
  'footer.email': 'Email: cd@uifox.com.cn',
  'footer.products': 'Products',
  'footer.about': 'About Us',
  'footer.company': 'Company',
  'footer.follow': 'Weixin Channels',
  'message.unread': '{count} unread',
  'message.next': 'Next',
  'message.noUnread': 'No unread messages',
  'message.empty': 'No messages',
  'message.viewMore': 'View More',
  'message.markAllRead': 'Mark all as read',
  'message.close': 'Close',
  'home.dataSubmission': 'Data Submission',
  'home.logisticsTracking': 'Freight Rates · Logistics Tracking',
  'home.rpaRobot': 'RPA Robot',
  'home.serviceScope': 'Service Scope',
  'home.consultGift': 'Consultation Gift',
  'home.shPremanifestTitle': 'Shanghai-Premanifest',
  'home.shPremanifestText': 'Fast Receipt & Smart Audit',
  'home.qdPremanifestTitle': 'Qingdao-Premanifest',
  'home.qdPremanifestText': 'Fast Receipt & Smart Audit',
  'home.emAciText': 'Provide 8000 code,<br/>safe and efficient, one-click sending',
  'home.afrTitle': 'AFR',
  'home.afrText': 'Provide AFR code,<br/>fast receipt, accurate and efficient',
  'home.amsTitle': 'AMS',
  'home.amsText': 'Provide SCAC code,<br/>No FMC Bond required, safe and simple',
  'home.isfTitle': 'ISF',
  'home.isfText': 'Provide SCAC code,<br/>No FMC Bond required, safe and simple',
  'home.icsTitle': 'ICS',
  'home.icsText': 'Safe and simple',
  'home.freightRateText': 'Global international ocean freight<br/>One-stop real-time query',
  'home.cargoTrackingTitle': 'Cargo Tracking',
  'home.cargoTrackingText': 'Global management & cycle prediction<br/>Support web version and WeChat subscription',
  'home.fullLinkTrackingTitle': 'Tracking',
  'home.fullLinkTrackingText': 'Full visualization tracking<br/>Real-time push of key nodes',
  'home.rpaDigitalEmployeeTitle': 'Digital Employees for Enterprises',
  'home.rpaDigitalEmployeeText': 'Integrate advanced technologies, use robots to replace<br/>manual operations, reduce costs and increase efficiency',
  'home.rpaAutomationTitle': 'Application Automation',
  'home.rpaAutomationText': 'Can realize automation of any desktop applications<br/>and web programs',
  'home.rpaInputAutomationTitle': 'Mouse and Keyboard Automation',
  'home.rpaInputAutomationText': 'Can control mouse and keyboard, replace manual effort<br/>to complete tedious processes',
  'agent.sinotrans': 'Sinotrans',
  'agent.sinounion': 'Sino-Union',
  'agent.huagang': 'Hua Gang',
  'agent.penavico': 'PENAVICO',
  'agent.zhenhua': 'Zhenhua',
  'agent.minsheng': 'Minsheng',
  'agent.hanghua': 'Hanghua',
  'agent.shunde': 'Shunde',
  'agent.penghua': 'Penghua',
  'agent.penghai': 'Penghai',
  'agent.sipg': 'SIPG',
  'agent.oocl': 'OOCL',
  'agent.xinhai': 'Xinhai',
  'agent.jincheng': 'Jincheng',
  menuLabels: {
    首页: 'Home',
    货代工具箱: 'Forwarder Toolkit',
    数据发送: 'Data Submission',
    海运跟踪: 'Ocean Tracking',
    无忧代理人: 'Agent',
    运价查询: 'Freight Rates',
    预配舱单: 'Manifest',
    预配舱单上海: 'Shanghai-Premanifest',
    预配舱单青岛: 'Qingdao-Premanifest',
    VGM发送: 'VGM',
    AMS发送: 'AMS',
    ISF发送: 'ISF',
    EM发送: 'EM',
    ACI发送: 'ACI',
    AFR发送: 'AFR',
    MPCI发送: 'MPCI',
    进出口箱货跟踪上海: 'Tracking - Shanghai',
    箱货跟踪宁波: 'Tracking - Ningbo',
    开截港查询上海: 'Cutoff Query - Shanghai',
    全链路跟踪: 'Tracking',
    客户推送订阅: 'Push Subscriptions',
    收藏订阅: 'Favorites',
    运价趋势: 'Rate Trends',
    货物跟踪: 'Ship Tracking',
    ICS2发送: 'ICS2',
    EMACI发送: 'EM & ACI'
  }
}
